module.exports = __webpack_public_path__ + "img/dox-label.91a34d64.svg";